<template>
  <div class="school_course_item">
    <div
      class="cover"
      :style="{
        'background-image': `url(${cover})`,
      }"
    >
      <div v-if="data.cover.includes('cover_')">{{ data.name }}</div>
    </div>
    <el-tooltip :content="data.name" placement="bottom">
      <p class="title">{{ data.name }}</p>
    </el-tooltip>

    <div class="info">
      <div>
        <img src="@/assets/images/cmp/userName_icon.png" alt="" />
        <span>{{ data.teacherName || "--" }}</span>
      </div>

      <div>
        <img src="@/assets/images/cmp/class_icon.png" alt="" />
        <span>{{ data.gradeName }}{{ data.volumeName }}</span>
      </div>

      <!-- <div>
        <img src="@/assets/images/cmp/grade_icon.png" alt="" />
        <span>1112131</span>
      </div> -->
    </div>
    <div class="footer">
      <p @click.stop="gotoCatalogue">详情</p>
      <template v-if="editable">
        <p @click.stop="bookUpAndDownStep1">{{ data.status === "UP" ? "下架" : "发布" }}</p>
        <p v-if="data.status === 'DOWN'" @click.stop="gotoEdit">编辑</p>
      </template>
      <p v-else-if="userInfo.type === 'TEACHER' ||userInfo.type === 'TEACHER_RESEARCH'" @click.stop="copy">复制</p>
      <p v-if="editable && data.status === 'DOWN'" @click.stop="deleteCourse">删除</p>
    </div>
    <el-dialog title="课程发布" :visible.sync="dialogVisible" width="350px" append-to-body>
      <div class="radio-item" v-for="(v, i) in courseTypeList" :key="i">
        <el-radio v-model="courseType" :label="v.name">{{ v.label }}</el-radio>
        <p>{{ v.content }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="bookUpAndDownStep2">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import utils from "@/assets/js/utils.js";
import publicUrl from "@/assets/js/interface";

export default {
  name: "cmp-course",
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      default: "0",
    },
    active: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    isPublic: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      courseType: "CLASS",
      courseTypeList: [
        { name: "CLASS", label: "班级可见", content: "发布后仅自己班级的学生可使用" },
        { name: "SCHOOL", label: "学校可见", content: "发布后全校师生均可查看使用" },
      ],
      // imgDict: {
      //   0: this.loadFile("res-0"),
      //   1: this.loadFile("res-1"),
      // },
    };
  },
  computed: {
    ...mapState({
      courseCoverList: (state) => state.courseCoverList,
      userInfo: (state) => state.userInfo,
    }),
    cover() {
      let img;
      if (this.data.cover) {
        img = this.data.cover.includes("cover_") ? this.courseCoverList[this.data.cover] : this.data.cover;
      } else {
        img = this.courseCoverList["cover_3"];
      }
      return img;
    },
    // resImage() {
    //   let type = this.type === "1" ? "1" : "0";
    //   return this.imgDict[type];
    // },
  },
  filters: {
    formatDate(val) {
      return utils.formatDate(val || 0, "yyyy-MM-dd");
    },
  },
  methods: {
    ...mapMutations({
      setCourseActiveId: "onlinecourses/setCourseActiveId",
    }),
    gotoCatalogue() {
      this.setCourseActiveId(this.data.id);

      this.$router.push({
        name: "onlinecourses-catalogue-editable",
        query: {
          id: this.data.id,
          status: "look",
        },
      });
    },
    gotoEdit() {
      this.setCourseActiveId(this.data.id);
      this.$router.push({
        name: "onlinecourses-catalogue-editable",
        query: {
          id: this.data.id,
        },
      });
    },
    deleteCourse() {
      this.loadingCount++;
      this.$ajaxJson
        .post(publicUrl.bookDelete, {
          id: this.data.id,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.$notify({
              position: "top-left",
              title: "成功",
              message: "删除成功",
              type: "success",
            });

            this.$emit("update");
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    copy() {
      this.loadingCount++;
      this.$ajaxJson
        .post(publicUrl.bookCopy, {
          id: this.data.id,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.$notify({
              position: "top-left",
              title: "成功",
              message: "复制成功",
              type: "success",
            });
          } else {
            this.$notify({
              position: "top-left",
              title: "失败",
              message: res.data.message || "复制失败",
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    bookUpAndDownStep1() {
      if (this.data.status === "UP") {
        this.courseType = this.data.type;
        this.bookUpAndDownStep2();
      } else {
        this.courseType = ["CLASS", "SCHOOL"].includes(this.data.type) ? this.data.type : "CLASS";
        this.dialogVisible = true;
      }
    },
    bookUpAndDownStep2() {
      this.loadingCount++;
      this.$ajaxJson
        .post(publicUrl.bookUpAndDown, {
          id: this.data.id,
          type: this.courseType,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.dialogVisible = false;
            this.$notify({
              position: "top-left",
              title: "成功",
              message: "操作成功",
              type: "success",
            });
            this.$emit("update");
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    // loadFile(filename) {
    // return require(`../../assets/images/home/${filename}.png`);
    // },
  },
};
</script>

<style scoped lang="less">
@import "@/assets/styles/public.less";
.school_course_item {
  width: 276px;
  background: #f3f8fb;
  border-radius: 20px;
  margin: 15px 0;

  .cover {
    width: 276px;
    height: 150px;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    background-repeat: no-repeat;
    background-size: cover;
    .flex_center;
    > div {
      width: 200px;
      height: 100px;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 20px;
      .flex_center;
      text-align: center;
      font-size: 24px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #333333;
      word-wrap: break-word;
    }
  }
  .title {
    padding: 4px 20px;

    font-size: 20px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    .ellipsis;
  }
  .info {
    padding: 0 20px 10px 20px;
    display: flex;
    // justify-content: space-between;
    > div {
      .flex_align_items;
      margin-right: 30px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
      span {
        font-size: 14px;
        font-family: SourceHanSansCN-ExtraLight, SourceHanSansCN;
        font-weight: 200;
        color: #333333;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 90px;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: space-around;
    border-top: 1px solid #e3ebf0;
    margin: 0 20px;
    padding-top: 10px;
    padding-bottom: 15px;
    p {
      font-size: 16px;
      font-family: SourceHanSansCN-Light, SourceHanSansCN;
      font-weight: 300;
      color: #00aaff;
      &:hover {
        cursor: pointer;
        opacity: 0.7;
      }
    }
  }
}
.radio-item {
  p {
    color: #9ea7b4;
    line-height: 2;
    text-indent: 24px;
  }
}
</style>
